/**
 * @fileoverview Agent definition for chapter-continuity-checker-v2.
 *
 * This agent analyzes a chapter against previous content to identify
 * continuity errors across plot, timeline, character, and world-building.
 *
 * @category narrative.prose.continuity
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-continuity-checker-v2',
  kind: 'primitive',
  name: 'Continuity Checker',
  description: 'Analyzes the current chapter against previous content to find continuity errors.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.continuity',
    usedBy: [
      'use-chapter-continuity-checker-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-continuity-checker-v2',
    ],
  },
};
